import { useQuery, useMutation } from '@apollo/client';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { HealthProfessionViewContainer } from './health-profession-view.container';
import {
  StaffHealthProfessionContainerBlobHealthProfessionsDocument,
  StaffHealthProfessionContainerHealthProfessionsUpdateDocument,
  HealthProfessionsData
} from '../../../../generated';
import { message } from 'antd';

export const HealthProfessionEditContainer = () => {
  const {
    data: professionData,
    loading: professionDataLoading,
    error: professionDataError
  } = useQuery(StaffHealthProfessionContainerBlobHealthProfessionsDocument, {
    fetchPolicy: 'network-only'
  });

  const [blobProfessionUpdate, { loading: updateLoading }] = useMutation(StaffHealthProfessionContainerHealthProfessionsUpdateDocument, {
    refetchQueries: [
      {
        query: StaffHealthProfessionContainerBlobHealthProfessionsDocument,
        variables: {
          blobData: {
            healthProfessions: []
          }
        }
      }
    ],
    awaitRefetchQueries: true
  });

  const removeTypename = (obj: { [x: string]: any; __typename: any }) => {
    const { __typename, ...rest } = obj;
    return rest;
  };

  const handleSave = async (data: any) => {
    const updatedHealthProfession = data.map((profession: any) => {
      const cleanedCountry = removeTypename(profession);
      return cleanedCountry;
    });

    try {
      await blobProfessionUpdate({
        variables: {
          input: {
            blobData: {
              healthProfessions: updatedHealthProfession
            }
          }
        }
      });
      message.success('Health profession details updated');
    } catch (error) {
      message.error(`Error Updating Health Profession: ${JSON.stringify(error)}`);
    }
  };

  return (
    <ComponentQueryLoader
      hasData={professionData?.blobHealthProfessions !== undefined}
      loading={professionDataLoading || updateLoading}
      error={professionDataError}
      hasDataComponent={
        <HealthProfessionViewContainer healthProfessions={professionData?.blobHealthProfessions?.healthProfessions as HealthProfessionsData[]} onSave={handleSave} />
      }
    />
  );
};
